import classNames from 'classnames';

import styles from './_index.module.scss';

const Column = ({ children, className, ...props }: React.HTMLAttributes<HTMLElement>) => {
  return (
    <div className={classNames(styles['column'], className)} {...props}>
      {children}
    </div>
  );
};

export default Column;
